<template>
  <div id="user-edit-tab-info" v-if="dataLocal">
    <!-- プロフィール写真 -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <div class="avatar-container">
            <figure>
              <img :src="photo" class="rounded h-24 w-24" border="0" />
              <figcaption v-show="!photo">{{ photoText }}</figcaption>
            </figure>
          </div>
          <div class="ml-8">
            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">
              {{ dataLocal.name }}
            </p>
            <vs-button type="border" class="mr-4" @click="showDialogUpload"
              >プロフィール画像を変更する</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 基本情報 -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input
          class="w-full mt-4"
          label="氏名"
          v-model="dataLocal.name"
          v-validate="'required'"
          name="name"
          data-vv-as="氏名"
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{
          errors.first("name")
        }}</span>

        <vs-input
          class="w-full mt-4"
          label="氏名(ローマ字)"
          v-model="dataLocal.name_en"
          v-validate="'required|alpha_spaces'"
          name="name_en"
          data-vv-as="氏名(ローマ字)"
        />
        <span class="text-danger text-sm" v-show="errors.has('name_en')">{{
          errors.first("name_en")
        }}</span>

      </div>

      <div class="vx-col md:w-1/2 w-full">
        <vs-input
          class="w-full mt-4"
          label="電話番号"
          v-model="dataLocal.phone_number"
          type="email"
          v-validate="'numeric|custom_phoneNumber'"
          name="phone_number"
          data-vv-as="電話番号"
        />
        <span class="text-danger text-sm" v-show="errors.has('phone_number')">{{
          errors.first("phone_number")
        }}</span>

        <vs-input
          class="w-full mt-4"
          label="Eメール"
          v-model="dataLocal.email_address"
          type="email"
          v-validate="'email'"
          name="email"
          data-vv-as="Eメール"
        />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{
          errors.first("email")
        }}</span>

        <vs-input 
          class="w-full mt-4"
          label="社員番号"
          v-model="dataLocal.origin_number"
          v-validate="'max:128'"
          name="origin_number"
          data-vv-as="社員番号"
        />
        <span class="text-danger text-sm" v-show="errors.has('origin_number')">{{
          errors.first("origin_number")
        }}</span>
      </div>
    </div>

    <!-- 更新 & リセット -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            id="button-with-loading"
            class="ml-auto mt-2"
            @click="saveChanges"
            :disabled="!validateForm"
            >変更を保存する</vs-button
          >
          <vs-button
            class="ml-4 mt-2"
            type="border"
            color="warning"
            @click="resetData"
            >リセット</vs-button
          >
        </div>
      </div>
    </div>
    <dialog-upload-profile-image
      ref="dialogUploadProfileImage"
      @onImageUploaded="onImageUploaded"
    ></dialog-upload-profile-image>
  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
import DialogUploadProfileImage from "@/components/dialogs/DialogUploadProfileImage";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("enterpriseUserEdit");

export default {
  components: {
    DialogUploadProfileImage
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    validateForm() {
      return !this.errors.any();
    }
  },
  data() {
    return {
      dataLocal: null,
      activePrompt: false,
      photo: null,
      photoText: ""
    };
  },
  watch: {
    user() {
      this.dataLocal = JSON.parse(JSON.stringify(this.user));
      this.createPhotoUrl();
    }
  },
  methods: {
    ...mapActions(["saveUser"]),

    createPhotoUrl() {
      if (this.user.pictures.length !== 0) {
        storage
          .child(this.user.pictures[0].thumbnail_path)
          .getDownloadURL()
          .then(response => {
            this.photo = response;
          });
      } else {
        this.photoText = "No image";
      }
    },

    async saveChanges() {
      if (!this.validateForm) {
        return;
      }
      this.$vs.loading({
        type: "default",
        container: "#button-with-loading",
        scale: 0.45
      });
      try {
        await this.saveUser({
          userId: this.$route.params.userId,
          data: this.dataLocal
        });
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        this.$vs.notify({
          title: "基本情報を更新しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        this.$emit('closePopup');
      } catch (e) {
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        this.$vs.notify({
          title: "基本情報の更新に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-check"
        });
      }
    },

    resetData() {
      this.dataLocal = JSON.parse(JSON.stringify(this.user));
    },

    showDialogUpload() {
      this.$refs.dialogUploadProfileImage.show();
    },

    async onImageUploaded(pictureData) {
      let data = JSON.parse(JSON.stringify(this.user));
      data.pictures[0] = pictureData.data;
      try {
        await this.saveUser({ userId: this.$route.params.userId, data: data });
        this.$vs.notify({
          title: "プロフィール画像を変更しました",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        this.photo = pictureData.url;
      } catch (e) {
        this.$vs.notify({
          title: "プロフィール画像の変更に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-check"
        });
      }
    }
  }
};
</script>

<style lang="scss">
.avatar-container {
  border-radius: 5px;
  background-color: black;
}
figure {
  position: relative;
}

figure img {
  vertical-align: top;
  background: #c0c0c0;
  object-fit: cover;
}

figure figcaption {
  font-size: 12px;
  color: #ffffff;
  position: absolute;
  top: 0;
  display: flex;
  width: 100%;
  height: 100%;
  margin: 0px;
  align-items: center;
  justify-content: center;
}
</style>
